// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-fields {
    display: flex;
    flex-direction: row;
    margin-left: 10%;
}

.search-fields1 {
    display: flex;
    flex-direction: row;
    margin-left: 4%;
}

.label-resource {
    margin: 2%;
    margin-top:5%;
    font-weight: 500;
    width: 100px;
}

.resource-search {
    width: 180px;
    margin:3%;
}
.resource-search1 {
    width: 10px;
    margin:3%;
    z-index: 100;
    position: fixed;
}

.data-table {
    z-index: 0;

}

.resource-inputs {
    margin-left: 2%;
}
.resource-accordion-inputs {
    margin-left: 2%;
}

.buttons-div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.accordion-button {
    height: 60px;
}

.button-name {
    margin: 1%;
    background: none;
    border: none;
    color: black
}

.button-icon {
    font-size: 30px;
}

.accordion {
    margin: auto;
    width: 56.5vw;
}

.accordion-body {
    height: 20vh;
    overflow: auto;
}


.switch-group {
    display: flex;
    flex-direction: row;
    margin-top: 6.5%;
    margin-left: 2.5%;
}

.switch-label {
    margin-right: 5%;
    font-weight: 500;
}

.add-button, .delete-button {
    font-size: 50px;
    cursor: pointer;
}

.add-button {
    margin-top: -10%;
    margin-left: 4%;
}

.add-button-div {
    margin-top: 6.5%;
}

.add-button-header {
    margin-top: 2.3%;
    margin-left: 80%;
}`, "",{"version":3,"sources":["webpack://./src/components/modules/userManagement/userReport/ResourceManagement.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,SAAS;AACb;AACA;IACI,WAAW;IACX,SAAS;IACT,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,UAAU;;AAEd;;AAEA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB","sourcesContent":[".search-fields {\n    display: flex;\n    flex-direction: row;\n    margin-left: 10%;\n}\n\n.search-fields1 {\n    display: flex;\n    flex-direction: row;\n    margin-left: 4%;\n}\n\n.label-resource {\n    margin: 2%;\n    margin-top:5%;\n    font-weight: 500;\n    width: 100px;\n}\n\n.resource-search {\n    width: 180px;\n    margin:3%;\n}\n.resource-search1 {\n    width: 10px;\n    margin:3%;\n    z-index: 100;\n    position: fixed;\n}\n\n.data-table {\n    z-index: 0;\n\n}\n\n.resource-inputs {\n    margin-left: 2%;\n}\n.resource-accordion-inputs {\n    margin-left: 2%;\n}\n\n.buttons-div {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n}\n\n.accordion-button {\n    height: 60px;\n}\n\n.button-name {\n    margin: 1%;\n    background: none;\n    border: none;\n    color: black\n}\n\n.button-icon {\n    font-size: 30px;\n}\n\n.accordion {\n    margin: auto;\n    width: 56.5vw;\n}\n\n.accordion-body {\n    height: 20vh;\n    overflow: auto;\n}\n\n\n.switch-group {\n    display: flex;\n    flex-direction: row;\n    margin-top: 6.5%;\n    margin-left: 2.5%;\n}\n\n.switch-label {\n    margin-right: 5%;\n    font-weight: 500;\n}\n\n.add-button, .delete-button {\n    font-size: 50px;\n    cursor: pointer;\n}\n\n.add-button {\n    margin-top: -10%;\n    margin-left: 4%;\n}\n\n.add-button-div {\n    margin-top: 6.5%;\n}\n\n.add-button-header {\n    margin-top: 2.3%;\n    margin-left: 80%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
